<!--<form   autocomplete="off">

    <nav class="toolbar navbar navbar-light">

    </nav>


    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Verificar Certificado</h4>




    </div>

</form>-->


<nav class="toolbar navbar navbar-light toolbar-no-button" autocomplete="off">
    <form class="form-inline">
        <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">

            <div class="col-md-12" style="display: inline-flex">

                <div class="md-col-3 pe-1">
                    <img src="/assets/images/MAPA.jpg" style="max-width: 250px; width: 100%; margin-right: 10px" />
                </div>

                <div class="col-md-9">
                    <h5>
                        Sistema de verificación de certificados fitosanitarios emitidos por el Ministerio de Agricultura, Pesca y Alimentación.
                    </h5>
                    <h6>
                        (System for verifying the phytosanitary certificate issued by Ministry of Agriculture, Fisheries and Feeding).
                    </h6>
                    <br />
                </div>

            </div>

            <div class="col-md-12 mt-3">
                <h4>Verificar Certificado</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->


                        <div class="row">

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpCodigo">Número de verificación del Certificado Fitosanitario:</label>
                                <p>(Verification number of Phytosanitary Certificate):</p>
                                <input formControlName="Token" name="Token" inputStyleClass="form-control" title="" class="form-control" id="inpCodigo" type="text" maxlength="250" value="">
                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('Token','required')">
                                    El Token no puede estar vacío para realizar la búsqueda
                                </div>
                            </div>

                        </div>



                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar / Search</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar / Clean</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify" style="margin-right: 6px"></i>Resultado de la validación <small style="margin-left: 4px">(Validation result)</small>
                    </div>

                    <div class="card-body-grid">

                        <div *ngIf="resultValidarCF !== null">

                            <div class="row" style="margin-top:10px;">

                                <div class="col-md-12">

                                    <strong style="margin-top:20px; margin-left: 12px">El certificado existe en Sede</strong>
                                    <p style="margin-left: 12px">(The certificate exists in Sede)</p>

                                </div>
                            </div>


                            <div class="row" style="margin-top:10px;">

                                <div class="col-md-12" style="display: inline-flex">

                                    <div class="md-col-3">
                                        <label class="col-form-label" for="inpNumeroLiquidacion" style="margin-left: 12px">Si desea descargar y ver el Certificado de Sede: </label>
                                        <p style="margin-left: 12px">(If you wish to download and view the Sede Certificate)</p>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Descargar CF" (click)="onDownload()" style="margin-top: 4px; margin-left:4px; max-height: 26px"><i class="fa fa-download"></i> Descargar / Download</button>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div *ngIf="resultValidarCF === null" class="empty-grid">
                            El certificado no existe en Sede
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
